module.exports = __webpack_public_path__ + "img/coffee.b57eaebb.png";